export default __webpack_public_path__ + "static/media/start-1.a61d1efa.jpg";